import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { Typography, message, Carousel, Button, Row, Col, Card, Icon } from "antd";
import { platformApi } from "../../../../api";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import CustomerInfo from "../../../FollowUp/CustomerInfo";
import ActivityLog from "../../../FollowUp/ActivityLog";
import WrappedCallingInterface from "../../../FollowUp/QuotationInfo/CallingInterface";
import SaleRegisterTable from "./SaleRegisterTable";
import FeedbackModal from "./FeedbackModal";
import VehicleSaleModal from "../../VehicleSaleInvoice/VehicleSaleModal";

const { Title } = Typography;

const SalesFeedbackCallDetails = (props) => {
  const location = useLocation();
  const { history, match } = props;
  const phoneNumber = match.params.phone;

  const [allCustomers, setCustomers] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [customerIds, setCustomerIds] = useState([]);
  
  const [saleRegisters, setSaleRegisters] = useState([]);
  const [activities, setActivities] = useState([]);
  
  const [callModal, setCallModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [viewSaleModal, setViewSaleModal] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);
  const [saleId, setSaleId] = useState("");
  const [selectedEngineNo, setSelectedEngineNo] = useState("");
  const [isEditView, setIsEditView] = useState(false);
  
  const [activeTab, setActiveTab] = useState(location?.state?.status || "NPF"); 

  useEffect(() => {
    getCustomersByPhone(phoneNumber);
  }, [phoneNumber]);

  const getCustomersByPhone = (phoneNo) => {
    platformApi.get(`/api/customer/phone-no/${phoneNo}`)
      .then((res) => {
        const { data: { response: { data: { customers } } } } = res;
        setCustomers(customers);
        if (customers.length) {
          const ids = customers.map((c) => c.id || c.customerId);
          setCustomerIds(ids);
          setCustomerId(customers[0].id || customers[0].customerId);
          getCustomerInfo(customers[0].id || customers[0].customerId);
          getSaleRegisters(ids);
          getActivityByCustomer(ids);
        }
      })
      .catch((err) => {
        message.error("Unable to get customer details");
      });
  };

  const getCustomerInfo = (id) => {
    platformApi.get(`/api/customer/${id}`).then((res) => {
      setCustomerDetails(res.data.response.data);
    });
  };

  const getSaleRegisters = (ids) => {
    platformApi.post("/api/saleRegister/getPage", {
      page: 1,
      size: 100,
      status: ["NPF","COMPLETED"],
      searchString: phoneNumber,
    }).then((res) => {
      const { data } = res;
      if (data.code === 200) {
        setSaleRegisters(data.data.saleRegisters || []);
      }
    });
  };

  const getActivityByCustomer = (ids = customerIds) => {
    platformApi.post("/api/activity/customers", {
      limit: 100,
      offset: 0,
      ids: ids,
    }).then((res) => {
      const { data: { response: { data } } } = res;
      // Filter for Sales Feedback Call
      const filtered = data.filter(act => act.activityType === "Sales Feedback");
      setActivities(filtered);
    }).catch(err => {
      // message.error("Unable to get activities");
    });
  };

  const updateCustomerData = (customer) => {
    platformApi.put(`/api/customer/${customer.id}`, customer)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Customer updated successfully");
          getCustomerInfo(customer.id);
        }
      });
  };

  const handleSaleView = (record) => {
    if (record.saleInvoice) {
      platformApi.get(`/api/saleInvoice/${record.saleInvoice.id}`).then((res) => {
        setSelectedSale(res.data.response.data || res.data.response);
        setIsEditView(true);
        setViewSaleModal(true);
      });
    } else {
      platformApi.get(`/api/saleRegister/getOne/${record.id}`).then((res) => {
        let { data } = res;
        if (data.code === 200) {
          setSaleId(data.data.id);
          setSelectedEngineNo(data.data.engineNo);
          const ds = { 
            ...data.data.saleData, 
            saleId: data.data.saleId,
            engineNo: data.data.engineNo,
            chassisNumber: data.data.chassisNumber,
            bookingId: data.data.bookingId
          };
          setSelectedSale(ds);
          setIsEditView(false);
          setViewSaleModal(true);
        }
      });
    }
  };

  const handleCallIconClick = (record) => {
    setSelectedSale(record);
    setCallModal(true);
  };

  const handleFeedbackClick = (record) => {
    setSelectedSale(record);
    setFeedbackModal(true);
  };

  const changeRecord = (next = false) => {
    platformApi.post("/api/saleRegister/scheduled", {
      status: activeTab,
      phone: phoneNumber,
      next
    }).then(res => {
      const { data } = res;
      if (data.code === 200 && data.response.data?.saleData) {
        const nextRecord = data.response.data;

        const phno = nextRecord.saleData?.customer?.contacts?.find(c => c.type === "Primary")?.phone || nextRecord.saleData?.customer?.contacts?.[0]?.phone;

        if (phno) {
          history.push({
            pathname: `/autoadmin/sales_feedback_call/${phno}`,
            state: {
              saleId: nextRecord.id,
              status: activeTab
            }
          });
          message.success("Record Fetched !!!");
        } else {
          message.error("Contact details not found for next record");
        }
      } else {
        message.info(next ? "No Next Record Exist" : "No Previous Record Exist");
      }
    }).catch(err => {
      message.error("Unable to fetch record",err);
    });
  };

  return (
    <div className="sales-feedback-call-details">
      <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={4}>
            <Button
              style={{ marginRight: 20 }}
              onClick={() => history.push("/autoadmin/sales_feedback_call")}
            >
              <LeftOutlined />
            </Button>
            Sales Feedback Call
          </Title>
        </Col>
      </Row>

      <Row type="flex" justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Button style={{ marginLeft: 20 }} onClick={() => changeRecord(false)}>Previous</Button>
        </Col>
        <Col>
          <Button style={{ marginRight: 20 }} onClick={() => changeRecord(true)}>Next</Button>
        </Col>
      </Row>

      <Card>
        <Row type="flex" gutter={[16, 16]} align="middle">
          <Col span={6}>
            <Carousel
              dots={false}
              beforeChange={(from, to) => {
                const nextCust = allCustomers[to];
                if (nextCust) {
                  setCustomerId(nextCust.id || nextCust.customerId);
                  getCustomerInfo(nextCust.id || nextCust.customerId);
                }
              }}
            >
              {allCustomers.map((cust) => (
                <div key={cust.id}>
                  {customerDetails && customerDetails.id === cust.id ? (
                    <CustomerInfo
                      customer={customerDetails}
                      setCustomer={setCustomerDetails}
                      updateCustomerData={updateCustomerData}
                    />
                  ) : (
                    <div style={{ height: 220, background: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      Loading...
                    </div>
                  )}
                </div>
              ))}
            </Carousel>
          </Col>
          
          <Col span={14}>
            <SaleRegisterTable 
              dataSource={saleRegisters} 
              onView={handleSaleView}
            />
          </Col>

          <Col span={4} style={{ textAlign: "center" }}>
            {saleRegisters.length > 0 && (
              saleRegisters[0].status === "COMPLETED" ? (
                <Button type="primary" onClick={() => handleFeedbackClick(saleRegisters[0])}>
                  Feedback
                </Button>
              ) : (
                <Button 
                  shape="circle" 
                  size="large" 
                  icon="phone" 
                  style={{ fontSize: 24, height: 60, width: 60 }}
                  onClick={() => handleCallIconClick(saleRegisters[0])}
                />
              )
            )}
          </Col>
        </Row>
      </Card>

      <div style={{ marginTop: 20 }}>
        <ActivityLog 
          customerId={customerId}
          dataSource={activities}
          getActivityByCustomer={getActivityByCustomer}
        />
      </div>

      {/* Modals */}
      <WrappedCallingInterface 
        visibility={callModal}
        setVisibility={setCallModal}
        customerDetail={customerDetails}
        getActivityByCustomer={getActivityByCustomer}
        activityType="Sales Feedback"
        isFeedbackCall={true}
        saleRegisterId={selectedSale?.id}
      />

      <FeedbackModal 
        visible={feedbackModal}
        onCancel={() => setFeedbackModal(false)}
        saleRegister={selectedSale}
        onSaveSuccess={() => {
          getSaleRegisters(customerIds);
          getActivityByCustomer();
        }}
      />

      {viewSaleModal && (
        <VehicleSaleModal 
          open={viewSaleModal}
          close={() => {
            setViewSaleModal(false);
            setSelectedSale(null);
          }}
          dataSource={selectedSale}
          saleId={saleId}
          setSaleId={setSaleId}
          engineNo={selectedEngineNo}
          isEdit={isEditView}
          editable={false}
        />
      )}
    </div>
  );
};

export default withRouter(SalesFeedbackCallDetails);
